Vue.asyncComponent('bp-block-type-group', {
    data() {
        return {
            isActive: false,
            isOpen: false,
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        blockTypes: {
            type: Array,
            required: true,
        },
        open: {
            type: Boolean
        },
        defaultOpen: {
            type: Boolean
        },
        searchActive: {
            type: Boolean
        },
        collapsedStates: {
            type: Object,
        }
    },
    methods: {
        /**
         * Block type drag start
         * @param type
         */
        childDragStart(type) {
            this.$emit('childDragStart', type);
        },
        /**
         * Stop dragging a block type
         */
        childDragStop() {
            this.$emit('childDragStop');
        },
        /**
         * Toggle is open
         */
        toggleIsOpen() {
            this.isOpen = !this.isOpen;

            // update the collapsed states
            const states = localStorage.getItem(`bp-block-group-collapsed-state`) ?
                    JSON.parse(localStorage.getItem(`bp-block-group-collapsed-state`)):
                    {};

            // update the state object
            states[this.id] = this.isOpen;

            localStorage.setItem(`bp-block-group-collapsed-state`, JSON.stringify(states));
        }
    },
    created() {
        this.isOpen = this.defaultOpen;

        if (this.collapsedStates && this.collapsedStates[this.id] !== undefined) {
            this.isOpen = this.collapsedStates[this.id];
        }
    }
}, 'blueprints/editor/bp-block-type-group.html');